// @flow
import { createAction } from 'redux-actions';

export const createDialog = createAction('CREATE_DIALOG');
export const removeDialog = createAction('REMOVE_DIALOG');

export const updateDialogProps = createAction('UPDATE_DIALOG_PROPS');

